import { Component, OnInit } from '@angular/core';
import { TableColumn } from '@shared/interface/table.interface';
import { UtilitiesService } from '@services/utilities.service';
import { API } from '@config/constants/api.constant';
import { BehaviorSubject } from 'rxjs';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { AuthService } from '@services/auth.service';
import { getDistributorTableColumns } from '../../../distributor.data';
import { IListDistributor } from '../../../interfaces/distributor.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { DistributorService } from '../../../distributor.service';

@Component({
  selector: 'app-edit-request',
  styleUrls: ['./edit-request.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_PENDING_EDIT_REQUEST"
      [tableColumns]="tableColumns"
      [privilegeDetail]="hasPrivilegeViewDetail"
      [useCustomActionLink]="true"
      (totalCount)="onTotalCount($event)"
      (actionLink)="handleActionDetail($event)"
    />
  `,
})
export class EditRequestComponent implements OnInit {
  userRole = '';
  hasPrivilegeViewDetail = new BehaviorSubject(false);
  tableColumns: TableColumn[] = getDistributorTableColumns('pending');

  public static totalCount = new BehaviorSubject(0);

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private rolePrivilegeService: RolePrivilegeService,
    public utilitiesService: UtilitiesService,
    private distributorService: DistributorService
  ) {}

  ngOnInit(): void {
    this.initPrivilegeCTA();
    this.tableColumns = this.utilitiesService.privilegeTableColumns(this.hasPrivilegeViewDetail.value, this.tableColumns);
  }

  initPrivilegeCTA() {
    this.userRole = this.authService.currentUserValue.role;
    this.hasPrivilegeViewDetail.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_MENUNGGU', 'TAB_LIST_SA_EDIT_REQUEST', 'CTA_VIEW_DETAIL'));
  }

  handleActionDetail(e: IListDistributor) {
    const _tab = this.activatedRoute.snapshot.params.tab;
    const { distributor_id } = e;
    return this.router.navigate([`${this.distributorService.BasePathDistributorDetail}/pending/${_tab}/${distributor_id}`]);
  }

  onTotalCount = (e: number) => EditRequestComponent.totalCount.next(e);

  protected readonly API = API;
}
